import type { ReactNode } from "react";
import { AnalyticsEventPayload } from "@swiggy-private/analytics/dist/interfaces";
import { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import type { IAnalytics } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";

import type { CrossSellConfig } from "@swiggy-private/portal-dineout-context";
import type { CrossSellNormalItem } from "./components/CrossSellContent/types";

export enum CustomWidgetTypes {
    MENU_CATEGORY_GRID = "type.googleapis.com/swiggy.presentation.dinersone.v1.MenuCategoryGrid",
    MENU_PARENT_CATEGORY_PILLS = "type.googleapis.com/swiggy.gandalf.widgets.v2.Pills",
    REFINE_WIDGET = "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidgetCustom",
    CROSS_SELL_WIDGET = "type.googleapis.com/swiggy.presentation.dinersone.v1.CrossSellWidget",
}

export enum WidgetTypes {
    DISH_WIDGET = "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    FAB_WIDGET = "type.googleapis.com/swiggy.gandalf.widgets.v2.FloatingActionWidget",
    POPUP_WIDGET = "type.googleapis.com/swiggy.gandalf.widgets.v2.PopUpWidget",
    ITEM_CATEGORY_TYPE = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    NESTED_ITEM_CATEGORY_TYPE = "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
    MENU_VEG_FILTER_AND_BADGE = "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
    CART_ITEM_LIST = "type.googleapis.com/swiggy.presentation.dinersone.v1.CartInfo",
    CTA_LIST = "type.googleapis.com/swiggy.presentation.dinersone.v1.CtaList",
    PARENT_ORDER_WIDGET = "type.googleapis.com/swiggy.presentation.dinersone.v1.ParentOrderWidget",
    PARENT_ORDER_LIST_WIDGET = "type.googleapis.com/swiggy.presentation.dinersone.v1.ParentOrderListWidget",
}

export interface FilterMenuDataParams {
    filteredData: IPLWidgetControllerCards[];
    initialData: IPLWidgetControllerCards[];
    itemExpandImpression: (analyticsData: Partial<AnalyticsEventPayload>) => void;
    /** Maps an item ID to its cross-sell render function, or undefined if none applies. */
    getCrossSellRenderer?: (itemId: string) => (() => ReactNode) | undefined;
}

export type { CrossSellConfig };

export enum UserCategory {
    PRIMARY = "Primary",
    SECONDARY = "Secondary",
}

export type ItemCard = {
    card: {
        "@type"?: string;
        info?: CrossSellNormalItem;
        analytics?: IAnalytics;
        renderCrossSellItems?: () => ReactNode;
    };
};

export type GetCrossSellRenderer = ((itemId: string) => (() => ReactNode) | undefined) | undefined;

export interface CrossSellAnalyticsParams {
    sourceItemId: string;
    filterEnabled: boolean;
    vegFilterEnabled: boolean;
}

export type MenuCategoryItem = {
    title?: string;
    categoryId?: string | number;
    itemCards?: ItemCard[];
};

export type MenuCategoryCardShape = {
    "@type"?: string;
    title?: string;
    categoryId?: string | number;
    parentType?: string;
    itemCards?: ItemCard[];
    categories?: MenuCategoryItem[];
};

export type MenuItemCategoryMeta = {
    collectionName: string;
    collectionId: string;
    parentType: string;
};

export interface ItemCategoryCardShape {
    itemCards?: ItemCard[];
    categories?: Array<{ itemCards?: ItemCard[] }>;
}
